/*=========================================================================================
  File Name: module-role-actions.js
  Description: Role Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import RoleAPI from '@/api/RoleAPI.js';
import httpClient from '../../api/axios-httpclient';
import commonFunc from '@/common/commonFunction';

export default {
	loadRoles: async function(context, payload) {
		context.commit('updateRolesLoaded', false);
		let res = await httpClient.getAsync({
			url: RoleAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()),
			params: payload
		});
		if (res && res.Success) {
			context.commit('updateRoles', res);
		}
		context.commit('updateRolesLoaded', true);
		//Trả kết quả
		return res.Data;
	},

	loadAll: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: RoleAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + `/all`
		});
		if (res && res.Success) {
			context.commit('updateAllRoles', res);
		}
		//Trả kết quả
		return res.Data;
	},

	getRoleById: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: RoleAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + `/${payload}`
		});
		if (res && res.Success) {
			return res.Data;
		}
		return null;
	},

	createRole: async function(context, payload) {
		let res = await httpClient.postAsync(
			{
				url: RoleAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/createrole',
				data: payload
			},
			true
		);
		return res;
	},

	updateRole: async function(context, payload) {
		let res = await httpClient.putAsync(
			{
				url: RoleAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/updaterole',
				data: payload
			},
			true
		);
		return res;
	},

	deleteRole: async function(context, payload) {
		let res = await httpClient.deleteAsync(
			{
				url: RoleAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + '/deleterole/' + payload.Id
			},
			true
		);
		if (res && res.Success) {
			context.commit('deleteRole', payload);
		}
		//Trả kết quả
		return res;
	},

	/**
	 * Lấy tổng số bản ghi trên danh sách
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 */
	getTotalPageAsync: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: RoleAPI.getAPIUrlSubParam(commonFunc.getSubParamSubOnly()) + `/total`,
			data: payload
		});
		if (res && res.Success) {
			context.commit('updateTotalPage', res.Data);
		}
		return 0;
	}
};
